/**
 * Shared Features List Component for Checkout Pages
 * Displays the list of premium features with checkmarks
 */

import React from 'react';
import { CheckCircle } from 'lucide-react';

export const CheckoutFeaturesList: React.FC = () => {
  const features = [
    {
      title: 'Your Complete Identity Map',
      description:
        'Personalized analysis of your fragmentation patterns, blind spots, and core identity',
    },
    {
      title: '20+ Specialized AI Companions',
      description:
        'DISC, Enneagram, Attachment, Shadow Work, Human Design, Myers-Briggs, and more\nEach one trained on YOUR specific quiz results',
    },
    {
      title: 'Daily Micro-Exercises (5 minutes)',
      description:
        'Increase self-awareness without overwhelm\nDesigned for your specific blind spots',
    },
    {
      title: 'Pattern Recognition Training',
      description:
        'Learn to spot patterns BEFORE they sabotage you\nReal-time feedback on your behaviors',
    },
    {
      title: 'Integration Protocols',
      description:
        'Step-by-step guidance to become ONE person\nStop performing multiple versions of yourself',
    },
  ];

  return (
    <div className="bg-white/95 dark:bg-kind-graphite/95 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200 dark:border-white/10 p-8">
      <h2 className="text-2xl font-title font-medium text-kind-text-primary mb-6">
        What's Included
      </h2>

      <div className="space-y-6">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <CheckCircle className="h-5 w-5 text-violet-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-kind-text-primary mb-2">{feature.title}</h3>
              <p className="text-sm text-kind-text-secondary whitespace-pre-line leading-relaxed">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
